import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const prismTabGroupCss = ":host{display:block;overflow-x:auto}.pwc-tab-group-parent{display:flex;flex-direction:row}.pwc-tab-group-content{border:1px solid var(--prism-color-theme-neutral-pop)}prism-tab{max-width:100%}.dragging{border:0;margin:0;outline:0;overflow:hidden;opacity:0%;white-space:nowrap;transition:max-width 0.3s ease-in, margin 0.3s ease-in}.narrow{max-width:1px}.hovered{transition:margin 0.025s ease-in}";
const PrismTabGroupStyle0 = prismTabGroupCss;

const sharedCss = ".prism-headline-mega{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20);text-transform:uppercase;}.prism-headline-mega-inlined{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-90);text-transform:uppercase;}.prism-headline-2xl{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-2xl-inlined{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-xl{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-xl-inlined{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-large{font-size:var(--prism-typography-global-type-scale-step5);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30)}.prism-headline-medium{font-size:var(--prism-typography-global-type-scale-step4);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-small{font-size:var(--prism-typography-global-type-scale-step3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-headline-xs{font-size:var(--prism-typography-global-type-scale-step2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-subtitle-1{font-size:var(--prism-typography-global-type-scale-step1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-subtitle-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-1,body{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-large);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-button,button{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100)}.prism-caption,caption,figcaption{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-overline{font-size:var(--prism-typography-global-type-scale-step-2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-larger);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.prism-microlabel{font-size:var(--prism-typography-global-type-scale-step-3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-largest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.pwc-none{display:none}.pwc-visually-hidden{border:0;height:0;margin:0;padding:0;outline:0;overflow:hidden;position:absolute;white-space:nowrap;width:1px;appearance:none}.pwc-input-label{position:absolute;left:0;top:50%;transform:translateY(-50%);transition:0.1s ease-out;transform-origin:left top;pointer-events:none}.pwc-input{outline:none;background-color:transparent;color:var(--prism-color-theme-ink);padding:var(--prism-spacing-global-small) 0;width:100%}";
const PrismTabGroupStyle1 = sharedCss;

const PrismTabGroup$1 = /*@__PURE__*/ proxyCustomElement(class PrismTabGroup extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        // Variables for updating tab appearance during dragging
        this.onTabLeft = false;
        this.tabDraggedOver = false;
        this.tabMidpoint = 0;
    }
    /** Listen for tab selection event */
    handleTabSelection(event) {
        this.tabElements.forEach((tab, index) => {
            if (tab.tabId === event.detail.tabId) {
                tab.selected = true;
                tab.tabIndex = 0;
                this.focusedTabIndex = index;
            }
            else {
                tab.selected = false;
                tab.tabIndex = -1;
            }
        });
    }
    /** Listen for left and right arrow keys to switch focus between tabs */
    handleKeyDown(event) {
        const key = event.key;
        if (key === 'Tab') {
            if (this.focusedTabIndex === undefined || this.focusedTabIndex === -1) {
                this.focusedTabIndex = 0;
            }
            else {
                this.focusedTabIndex = (this.focusedTabIndex + 1) % this.tabElements.length;
            }
            this.focusTab();
        }
        if (key === 'ArrowLeft') {
            if (this.focusedTabIndex === undefined || this.focusedTabIndex === -1) {
                this.focusedTabIndex = 0;
            }
            else if (this.focusedTabIndex === 0) {
                this.focusedTabIndex = this.tabElements.length - 1;
            }
            else {
                this.focusedTabIndex = (this.focusedTabIndex - 1) % this.tabElements.length;
            }
            this.focusTab();
        }
        if (key === 'ArrowRight') {
            if (this.focusedTabIndex === undefined || this.focusedTabIndex === -1) {
                this.focusedTabIndex = this.tabElements.length - 1;
            }
            else {
                this.focusedTabIndex = (this.focusedTabIndex + 1) % this.tabElements.length;
            }
            this.focusTab();
        }
    }
    render() {
        return (h(Host, { key: '5f3e2a1848501f9e8b4fdf4246432de5d767ae60', role: "tablist" }, h("div", { key: 'd7840463bafd35e83929cc2d7b6808ddfb762a97', class: "pwc-tab-group-parent", ref: (el) => (this.containerElement = el), onDragStart: (e) => this.dragStart(e), onDragEnd: (e) => this.dragEnd(e), onDragOver: (e) => this.dragOver(e), onDragEnter: (e) => this.dragEnter(e), onDragLeave: (e) => this.dragLeave(e) }, h("slot", { key: 'c5cf816e6d571ad552dba963859966e4043de944', onSlotchange: () => this.slotChange() }))));
    }
    /** Listen for dragstart, keep track of the original index of the tab */
    dragStart(event) {
        this.draggingTab = event.target;
        this.draggingTabStartIndex = this.getTabIndex(this.draggingTab);
        this.draggingTabWidth = this.draggingTab.scrollWidth;
    }
    /** Save the currently hovered tab and reset its appearance when we start dragging over a new tab */
    dragEnter(event) {
        event.preventDefault();
        this.draggingTab.classList.add('dragging');
        const dragoverTab = event.target;
        if (dragoverTab !== null && dragoverTab !== this.draggingTab && dragoverTab.tagName === 'PRISM-TAB') {
            this.draggingTab.classList.add('narrow');
            if (!this.currentlyHoveredTab) {
                this.currentlyHoveredTab = dragoverTab;
            }
            else if (dragoverTab !== this.currentlyHoveredTab) {
                this.currentlyHoveredTab.style.margin = '';
                this.tabMidpoint = 0;
                this.tabDraggedOver = false;
                this.onTabLeft = false;
                this.currentlyHoveredTab = dragoverTab;
            }
        }
    }
    /**	Keep track of which tab we're dragging over so we know what to swap once the dragging ends, and
    change how the tab looks as the user drags over it. */
    dragOver(event) {
        event.preventDefault();
        const dragoverTab = event.target;
        // Get current index and the midpoint of the tab and change its appearance if needed
        if (dragoverTab !== null && dragoverTab !== this.draggingTab && dragoverTab.tagName === 'PRISM-TAB') {
            this.draggingTabEndIndex = this.getTabIndex(dragoverTab);
            if (!this.tabDraggedOver) {
                this.tabDraggedOver = true;
                const rect = dragoverTab.getBoundingClientRect();
                this.tabMidpoint = rect.left + rect.width / 2;
                this.onTabLeft = event.clientX < this.tabMidpoint;
                this.setMargin(dragoverTab);
            }
            else if ((this.onTabLeft && event.clientX > this.tabMidpoint) ||
                (!this.onTabLeft && event.clientX < this.tabMidpoint)) {
                this.onTabLeft = !this.onTabLeft;
                this.setMargin(dragoverTab);
            }
        }
        else {
            this.cancelEvent(event);
        }
    }
    dragLeave(event) {
        event.preventDefault();
    }
    /** On drag end, swap the tabs (if the tab being dragged was dropped on another tab) */
    dragEnd(event) {
        var _a;
        if (this.draggingTabEndIndex === undefined || this.draggingTabEndIndex === -1) {
            this.containerElement.insertBefore(this.draggingTab, this.draggingTab.nextElementSibling);
            this.draggingTab.style.margin = '';
        }
        else if (this.draggingTabEndIndex !== this.draggingTabStartIndex) {
            const hoveredTab = this.tabElements[this.draggingTabEndIndex];
            hoveredTab.classList.add('hovered');
            if (hoveredTab.style.marginLeft) {
                this.containerElement.insertBefore(this.draggingTab, hoveredTab);
            }
            else {
                this.swapTabs(this.draggingTab, hoveredTab);
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            hoveredTab.style.margin = '';
            this.draggingTab.style.margin = '';
            setTimeout(() => hoveredTab.classList.remove('hovered'), 250);
        }
        event.target.classList.remove('narrow');
        event.target.classList.remove('dragging');
        // Reset order of tabElements for keyboard navigation
        this.tabElements = [...this.containerElement.querySelectorAll('prism-tab')];
        this.focusedTabIndex = (_a = this.draggingTabEndIndex) !== null && _a !== void 0 ? _a : 0;
        this.draggingTab = null;
        this.draggingTabStartIndex = undefined;
        this.draggingTabEndIndex = undefined;
        this.cancelEvent(event);
    }
    /** Take the slotted tabs and add them as direct children of the tab group container div.
    This helps the drag event listeners work correctly. */
    slotChange() {
        const tabs = [...this.hostElement.querySelectorAll('prism-tab')];
        let tabsInitialized = false;
        tabs.forEach((tab) => {
            this.containerElement.appendChild(tab);
            if (!tabsInitialized) {
                tab.tabIndex = 0;
                this.focusedTabIndex = 0;
                tabsInitialized = true;
            }
        });
        this.tabElements = [...this.containerElement.querySelectorAll('prism-tab')];
    }
    /** Set the margin on a tab that's being dragged over */
    setMargin(element) {
        if (this.onTabLeft) {
            element.style.marginRight = '';
            element.style.marginLeft = `${this.draggingTabWidth}px`;
        }
        else {
            element.style.marginLeft = '';
            element.style.marginRight = `${this.draggingTabWidth}px`;
        }
    }
    focusTab() {
        this.tabElements.forEach((tab, index) => {
            if (index === this.focusedTabIndex) {
                tab.tabIndex = 0;
                tab.focus();
            }
            else {
                tab.tabIndex = -1;
            }
        });
    }
    /** Get the index of a single tab within the list */
    getTabIndex(tab) {
        return Array.prototype.slice.call(this.tabElements).indexOf(tab);
    }
    /** Swap two tabs */
    swapTabs(draggedTab, hoveredTab) {
        const beforeHoveredTab = hoveredTab.previousElementSibling;
        if (draggedTab === beforeHoveredTab) {
            this.containerElement.insertBefore(hoveredTab, draggedTab);
        }
        else {
            this.containerElement.insertBefore(draggedTab, hoveredTab.nextElementSibling);
        }
    }
    cancelEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
    get hostElement() { return this; }
    static get style() { return PrismTabGroupStyle0 + PrismTabGroupStyle1; }
}, [1, "prism-tab-group", undefined, [[0, "selectTab", "handleTabSelection"], [0, "keydown", "handleKeyDown"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["prism-tab-group"];
    components.forEach(tagName => { switch (tagName) {
        case "prism-tab-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PrismTabGroup$1);
            }
            break;
    } });
}

const PrismTabGroup = PrismTabGroup$1;
const defineCustomElement = defineCustomElement$1;

export { PrismTabGroup, defineCustomElement };

